import React from 'react';
import { translate } from 'react-jhipster';
import { NavDropdown } from './menu-components';
import { Nav } from 'reactstrap';
import { EntitiesMenu as EntitiesMenuItems } from 'app/entities/menu';

export const EntitiesMenu = () => (
  <Nav
    vertical
    icon="th-list"
    name={translate('global.menu.entities.main')}
    id="entity-menu"
    data-cy="entity"
    style={{ maxHeight: '80vh', overflow: 'auto' }}
  >
    {/* <EntitiesMenuItems />*/}
  </Nav>
);
